import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ECapReportStepProps } from ".";
import { DATE_UTIL } from "../../../../utils/dateUtils";
import OutPutTable from "../shared/output-table";



const ViewResult = (props: ECapReportStepProps) => {

    const { t } = useTranslation();

    const next = (values: any) => {
        if (props.next) {
            props.next();
        }
    }

    return (
        <React.Fragment>
            <div className="result-title">
                <h4 >
                    {t("RapmReport.lbOutputData")}
                </h4>
                <span>
                    {DATE_UTIL.convertServerToViewDateTimeFormat(props.created_on)}
                </span>
            </div>

            {
                props.outputData && props.outputData?.map((item, index) => (
                    <div key={index} className="output-wrapper">
                        <p className="table-des">
                            {item.type_desc}
                        </p>
                        <OutPutTable type={props.risk_type} data={item.data} />
                    </div>
                ))
            }

            <div className="action">
                <Button type="primary" shape="round" onClick={next}>
                    {t("RapmReport.btnSubmit")}
                </Button>
            </div>
        </React.Fragment>
    )
}

export default ViewResult;